{
	"title": "Openstaande facturen",
	"description": "Facturen van orders op rekening die nog niet betaald zijn. Een herinnering mail je hier zelf; er gaat niets automatisch.",
	"searchLabel": "Zoek op factuurnummer, ordernummer, klant of e-mailadres",
	"empty": "Er staan geen facturen open.",
	"backToOrders": "Orders",
	"summary": {
		"overdue_one": "{{count}} factuur is vervallen, samen {{amount}}.",
		"overdue_other": "{{count}} facturen zijn vervallen, samen {{amount}}.",
		"noneOverdue": "Geen enkele factuur is vervallen."
	},
	"column": {
		"number": "Factuur",
		"customer": "Klant",
		"total": "Bedrag",
		"dueOn": "Vervaldatum",
		"reminder": "Herinnering"
	},
	"state": {
		"label": "Status",
		"notDue": "Nog niet vervallen",
		"overdue": "Vervallen"
	},
	"order": "Order {{orderNumber}}",
	"daysOverdue_one": "{{count}} dag te laat",
	"daysOverdue_other": "{{count}} dagen te laat",
	"dueIn": "Nog niet vervallen",
	"noReminder": "Nog geen",
	"reminders_one": "{{count}}× gemaild, laatst {{date}}",
	"reminders_other": "{{count}}× gemaild, laatst {{date}}",
	"remind": "Herinnering mailen",
	"remindLabel": "Herinnering mailen voor {{number}}",
	"reminded": "Herinnering voor {{number}} gemaild aan {{email}}.",
	"remindFailed": "De herinnering kon niet worden verstuurd. Probeer het opnieuw.",
	"notOpen": "Deze factuur is intussen betaald of de order is geannuleerd.",
	"remindedToday": "Er is vandaag al een herinnering voor deze factuur gemaild. Klik nog eens om er nog een te sturen.",
	"againTitle": "Nog een herinnering voor {{number}}?",
	"againDescription": "Je hebt vandaag al een herinnering gemaild aan {{email}} ({{date}}). Wil je er nog een sturen?",
	"againConfirm": "Ja, nog een herinnering mailen",
	"help": {
		"openInvoices": {
			"title": "Openstaande facturen",
			"area": "Orders › Openstaande facturen",
			"short": "De facturen van orders op rekening die nog niet betaald zijn, de vroegste vervaldatum bovenaan. Is er een vervallen, dan staat erboven hoeveel het er zijn en voor welk bedrag.",
			"terms": ["order:onAccount", "invoice:dueState", "invoice:reminder", "invoice:invoice"]
		},
		"dueState": {
			"title": "Vervallen",
			"area": "Orders › Openstaande facturen",
			"short": "Een factuur is vervallen als de vervaldatum voorbij is: de factuurdatum plus de betaaltermijn van de klant.",
			"choices": [
				{
					"name": "Nog niet vervallen",
					"text": "De klant heeft nog tijd om te betalen."
				},
				{
					"name": "Vervallen",
					"text": "De vervaldatum is voorbij; je ziet hoeveel dagen te laat."
				}
			],
			"terms": ["invoice:reminder"]
		},
		"reminder": {
			"title": "Herinnering",
			"area": "Orders › Openstaande facturen",
			"short": "Met Herinnering mailen krijgt de klant een betalingsherinnering voor de factuur. Die komt in de historie van de order en in het maillog, met hoe vaak je al herinnerde.",
			"warning": "Er gaat nooit vanzelf een herinnering. Heb je er vandaag al een gestuurd, dan vraagt de knop eerst of het nog eens moet.",
			"terms": ["order:history"]
		},
		"invoice": {
			"title": "Factuur",
			"area": "Orders › Factuur",
			"short": "Elke betaalde order en elke order op rekening krijgt een factuur: CBI- en een doorlopend nummer vanaf 100000. De pdf blijft zoals hij gemaakt is en gaat met de bevestiging naar de klant.",
			"warning": "Lukt het maken of de mail niet, dan zie je hier Factuur maken of Bevestiging versturen.",
			"terms": ["invoice:creditInvoice", "invoice:reverseCharge", "order:onAccount", "order:orderNumber"]
		},
		"creditInvoice": {
			"title": "Creditfactuur",
			"area": "Orders › Factuur",
			"short": "Een creditfactuur draait een factuur helemaal of voor een deel terug: bij een terugbetaling, of bij annuleren op rekening. Hij heeft een eigen reeks, CBC- en een doorlopend nummer. De klant krijgt hem per mail.",
			"terms": ["order:refund", "invoice:invoice"]
		},
		"reverseCharge": {
			"title": "Btw verlegd",
			"area": "Orders › Factuur",
			"short": "Is de btw van een zakelijke klant verlegd, dan staat er 0% btw op de factuur, met de vermelding dat de btw verlegd is. Of dat zo is, beslis je bij het goedkeuren van zijn zakelijk profiel.",
			"terms": ["invoice:invoice", "customer:reverseCharge"]
		}
	}
}
